import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconIntegrationGradient(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 18.2444C10.8662 19.0353 9.48725 19.4991 8 19.4991C4.13401 19.4991 1 16.3651 1 12.4991C1 8.63309 4.13401 5.49908 8 5.49908C9.48725 5.49908 10.8662 5.9629 12 6.75377C13.1338 5.9629 14.5128 5.49908 16 5.49908C19.866 5.49908 23 8.63309 23 12.4991C23 16.3651 19.866 19.4991 16 19.4991C14.5128 19.4991 13.1338 19.0353 12 18.2444ZM3 12.4991C3 9.73766 5.23858 7.49908 8 7.49908C8.91083 7.49908 9.76477 7.74263 10.5003 8.16815C9.56068 9.35967 9 10.8639 9 12.4991C9 14.1343 9.56068 15.6385 10.5003 16.83C9.76477 17.2555 8.91083 17.4991 8 17.4991C5.23858 17.4991 3 15.2605 3 12.4991ZM13.4997 8.16815C14.2352 7.74263 15.0892 7.49908 16 7.49908C18.7614 7.49908 21 9.73766 21 12.4991C21 15.2605 18.7614 17.4991 16 17.4991C15.0892 17.4991 14.2352 17.2555 13.4997 16.83C14.4393 15.6385 15 14.1343 15 12.4991C15 10.8639 14.4393 9.35967 13.4997 8.16815ZM12 9.4986C12.6279 10.3343 13 11.3733 13 12.4991C13 13.6249 12.6279 14.6638 12 15.4996C11.3721 14.6638 11 13.6249 11 12.4991C11 11.3733 11.3721 10.3343 12 9.4986Z"
        fill="url(#paint0_linear_402_5526)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_402_5526"
          x1="1"
          y1="5.49908"
          x2="20.1345"
          y2="22.6888"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#337FFF" />
          <stop offset="1" stopColor="#E039CE" />
        </linearGradient>
      </defs>
    </BaseIcon>
  );
}
